import axios from 'axios';
import store from '@/store';

// Implicit grant flow
export const SPOTIFY_API_DEFAULTS = {
  baseURL: process.env.VUE_APP_SPOTIFY_API_URL,
  headers: {
    Authorization: '',
  },
};

// Backend Instance
export const AXIOS_DEFAULTS = {
  baseURL: process.env.VUE_APP_BACKEND_URL,
  headers: {
    Authorization: '',
  },
};

export const refreshAxiosInstance = () => {
  if (store.getters.isAuthenticated) {
    AXIOS_DEFAULTS.headers.Authorization = `Bearer ${store.getters.authToken}`;
  }
  window.axios = axios.create(AXIOS_DEFAULTS);

  /* eslint-disable no-underscore-dangle */
  if (store.getters.isAuthenticated) {
    if (window._userAccessTimer) {
      clearInterval(window._userAccessTimer);
    }
    window._userAccessTimer = setInterval(() => {
      store.dispatch('refresh');
    }, store.getters.userAccessTokenExpirationTime);
  }
  /* eslint-enable no-underscore-dangle */
};

export const refreshSubUserAxiosInstance = () => {
  if (store.getters.isSubUserAuthenticated) {
    AXIOS_DEFAULTS.headers.Authorization = `Bearer ${store.getters.subUserAuthToken}`;
    window.axios = axios.create(AXIOS_DEFAULTS);
  }
};

export const refreshSpotifyInstance = () => {
  if (store.getters.isAuthenticated) {
    SPOTIFY_API_DEFAULTS.headers.Authorization = `Bearer ${store.getters.spotifyAccessToken}`;
  }
  window.spotify = axios.create(SPOTIFY_API_DEFAULTS);

  /* eslint-disable no-underscore-dangle */
  if (store.getters.isAuthenticated) {
    if (window._spotifyAccessTimer) {
      clearInterval(window._spotifyAccessTimer);
    }
    window._spotifyAccessTimer = setInterval(() => {
      store.dispatch('authorizeSpotifyApp');
    }, store.getters.spotifyAccessTokenExpirationTime);
  }
  /* eslint-enable no-underscore-dangle */
};

export const refreshSpotifyUserInstance = () => {
  if (store.getters.isAuthenticated) {
    SPOTIFY_API_DEFAULTS.headers.Authorization = `Bearer ${store.getters.spotifyUserAccessToken}`;
  }
  window.spotifyUser = axios.create(SPOTIFY_API_DEFAULTS);
};

export const initAxiosInstances = () => {
  refreshAxiosInstance();
  refreshSubUserAxiosInstance();
  refreshSpotifyInstance();
  refreshSpotifyUserInstance();
};
